// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreatePerformanceReviewMutationVariables = Types.Exact<{
  input: Types.CreatePerformanceReviewInput;
}>;

export type CreatePerformanceReviewMutation = { __typename?: 'Mutation' } & {
  createPerformanceReview: { __typename?: 'CreatePerformanceReviewOutput' } & Pick<
    Types.CreatePerformanceReviewOutput,
    'alreadyExists' | 'id'
  >;
};

export const CreatePerformanceReviewDocument = /*#__PURE__*/ gql`
    mutation CreatePerformanceReview($input: CreatePerformanceReviewInput!) {
  createPerformanceReview(input: $input) {
    alreadyExists
    id
  }
}
    `;
export type CreatePerformanceReviewMutationFn = Apollo.MutationFunction<
  CreatePerformanceReviewMutation,
  CreatePerformanceReviewMutationVariables
>;

/**
 * __useCreatePerformanceReviewMutation__
 *
 * To run a mutation, you first call `useCreatePerformanceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerformanceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerformanceReviewMutation, { data, loading, error }] = useCreatePerformanceReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerformanceReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>(
    CreatePerformanceReviewDocument,
    options,
  );
}
export type CreatePerformanceReviewMutationHookResult = ReturnType<typeof useCreatePerformanceReviewMutation>;
export type CreatePerformanceReviewMutationOptions = Apollo.BaseMutationOptions<
  CreatePerformanceReviewMutation,
  CreatePerformanceReviewMutationVariables
>;
